<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Subentro </v-toolbar-title>
      <v-spacer></v-spacer>

      <!-- Bottone per l'invio di username e password -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickInviaCredenziali" v-bind="attrs" v-on="on">
            <v-icon color="success" large> mdi-check </v-icon>
          </v-btn>
        </template>
        <span>Invia</span>
      </v-tooltip>

      <v-spacer></v-spacer>
      <!-- Bottone di chiusura -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" v-bind="attrs" v-on="on">
            <v-icon color="error" large> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-5">
      <v-card outlined>
        <v-card-text>
          <span style="font-size: 20px">
            Immettere le credenziali del nuovo operatore per registrare il
            subentro
          </span>
          <v-container>
            <v-row align="center" justify="center">
              <v-col align="center" cols="12" justify="center">
                <!-- Text field dello username -->
                <v-text-field
                  background-color="#ffffff"
                  class="input-class centered-input"
                  dense
                  height="50px"
                  hide-details
                  label="Username"
                  style="
                    display: inline-block;
                    font-size: 20px;
                    font-weight: bold;
                    line-height: 25px;
                    padding: 0px;
                    min-width: 150px;
                  "
                  v-model="username"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col align="center" cols="12" justify="center">
                <!-- Text field della password -->
                <v-text-field
                  background-color="#ffffff"
                  class="input-class centered-input"
                  dense
                  height="50px"
                  hide-details
                  label="Password"
                  style="
                    display: inline-block;
                    font-size: 20px;
                    font-weight: bold;
                    line-height: 25px;
                    padding: 0px;
                    min-width: 150px;
                  "
                  type="password"
                  v-model="password"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <!-- Select dei turni -->
      <v-container class="mt-3" v-if="is_turno_obbligatorio">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <span style="font-size: 20px; line-height: 35px">
              Il subentrante non ha eseguito un login recentemente.<br />
              Indicare il turno di riferimento:
            </span>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col align="center" cols="12">
            <v-select
              :items="tipi_turno"
              label="Turno del Subentrante"
              item-text="cod_turno"
              item-value="id_turno"
              style="
                display: inline-block;
                font-size: 20px;
                font-weight: bold;
                line-height: 25px;
                padding: 0px;
                min-width: 150px;
              "
              v-model="turno_selezionato"
            >
            </v-select>
          </v-col>
        </v-row>
      </v-container>
      <v-container>
        <v-row align="center" class="mt-2" justify="center">
          <v-col align="center" cols="12" justify="center">
            <!-- Bottone per attivare il lettore di QR code -->
            <v-btn @click="clickQRCode" icon>
              <v-icon color="primary" x-large> mdi-qrcode-scan </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Dialog del QR code reader -->
    <v-dialog v-model="qr_reader_visible" persistent>
      <v-toolbar>
        <v-toolbar-title> </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="handleCloseQRDialog" v-bind="attrs" v-on="on">
              <v-icon color="error" large> mdi-close </v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-toolbar>
      <qrcode-stream :camera="camera" @decode="handleOnDecode"></qrcode-stream>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="caricamento_dati" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "CambioBobina",
  components: { SnackbarQV },
  props: {
    work_order_sel: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      is_turno_obbligatorio: false,
      password: "",
      turno_selezionato: null,
      username: "",
      username_tmp: "",

      // Modal
      qr_reader_visible: false,
      camera: "off",
      caricamento_dati: false,

      // Array
      tipi_turno: new Array(),
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    clickChiudi() {
      this.resetProperties();
      this.$emit("click_chiudi");
    },
    clickInviaCredenziali() {
      // Controllo che username e password siano specificati
      if (
        this.username === "" ||
        this.username === null ||
        this.username === undefined ||
        this.password === "" ||
        this.password === null ||
        this.password === undefined
      ) {
        this.$refs.SnackbarQV.print("error", "Valorizzare username e password");
        return;
      }

      /* Se c'è un prefisso, uso il prefisso che mi ha messo l'utente.
       * Se non c'è un prefisso, lo ricavo dal localStorage. */
      if (!this.username.includes("/")) {
        this.username_tmp = this.username;
      } else {
        this.username_tmp = this.username.split("/")[1];
      }

      // Controllo che lo username sia valorizzato correttamente.
      if (this.username_tmp == null || this.username_tmp == "") {
        this.$refs.SnackbarQV.print("orange", "Username non valido.");
      }

      // Controllo che ci sia il turno del subentrante.
      if (
        (this.turno_selezionato === null ||
          this.turno_selezionato === undefined ||
          this.turno_selezionato === "") &&
        this.is_turno_obbligatorio === true
      ) {
        console.log((this.turno_selezionato === null ||
          this.turno_selezionato === undefined ||
          this.turno_selezionato === "") &&
        this.is_turno_obbligatorio === true);
        this.$refs.SnackbarQV.print(
          "orange",
          "Selezionare il turno del subentrante."
        );

        return;
      }

      const request = {
        controller: "Token",
        method: "POST",
        richiesta: {
          action: "checkuser",
          token: localStorage.user_token,
          username: this.username_tmp,
          password: this.password,
          turno:
            this.turno_selezionato == null || this.turno_selezionato === ""
              ? -1
              : this.turno_selezionato,
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            // Se un utente cerca di subentrare a sé stesso, lo fermo.
            if (localStorage.id === res.data.id) {
              this.$refs.SnackbarQV.print(
                "orange",
                "Impossibile eseguire subentro: l'utente subentrante risulta identico all'utente subentrato."
              );

              return;
            }

            //  Info accesso ai moduli amministrativi
            let auth_level = Number(res.data.auth_level);
            if (auth_level >= 0) {
              auth_level = new Uint32Array([auth_level])[0];
            }
            localStorage.auth_level = auth_level;
            localStorage.show_admin_tools = auth_level == -1 || auth_level > 0;

            if (res.data.turno && res.data.turno != -1) {
              this.setSubentro(res.data.id, res.data.turno);
            } else {
              this.is_turno_obbligatorio = true;
              this.$refs.SnackbarQV.print(
                "orange",
                `Selezionare manualmente il turno.`
              );
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Non è possibile subentrare con queste credenziali (codice segnalazione: ${res.status}).`
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          if (err) {
            // Stampo una snackbar di errore
            if (err.response) {
              this.$refs.SnackbarQV.print(
                "orange",
                `${JSON.parse(err.response.data.message).result}.`
              );
            } else {
              this.$refs.SnackbarQV.print(
                "error",
                `Errore di comunicazione colserver.`
              );
              console.error(err);
            }
          }
        });
    },
    clickQRCode() {
      this.qr_reader_visible = true;
      this.camera = "auto";
    },
    getTurni() {
      this.caricamento_dati = true;

      var date = new Date();
      this.dateStr =
        date.getDate() + "/" + date.getMonth() + "/" + date.getFullYear();

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getturnocodici",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            for (let i = 0; i < res.data.result.turno_codici.length; i++) {
              this.tipi_turno.push(
                Object.assign({}, res.data.result.turno_codici[i])
              );
            }
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          console.error(err);
        });
    },
    handleCloseQRDialog() {
      this.qr_reader_visible = false;
      this.camera = "off";
    },
    handleOnDecode(arg) {
      this.username = arg.split("(Q)")[1].split(";")[0];
      this.password = arg.split("(H)")[1].split(";")[0];
      this.camera = "off";
      this.qr_reader_visible = false;

      this.clickInviaCredenziali();
    },
    resetProperties() {
      this.password = "";
      this.turno_selezionato = null;
      this.username = "";
      this.username_tmp = "";
      this.is_turno_obbligatorio = false;
    },
    setSubentro(arg_id, arg_turno) {
      // Faccio la chiamata setsubentro
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setsubentro",
          token: localStorage.getItem("user_token"),
          id_utente_old: this.work_order_sel.id_personale,
          id_utente_new: arg_id,
          id_commessa: this.work_order_sel.id_commessa,
          id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
          id_macchina: this.work_order_sel.id_macchina,
          id_turno_new: arg_turno,
        },
      };

      // Apro l'overlay
      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res2) => {
          if (res2.status === 200) {
            // Chiudo l'overlay
            this.caricamento_dati = false;

            this.resetProperties();

            // Mando un custom event alla fome per fare il refresh dei dati.
            // const evento = new CustomEvent("eseguito_subentro");
            // document
            //   .getElementById("general_app_bar")
            //   .dispatchEvent(evento);

            // Emetto un evento per aggiornare il componente attuale.
            this.$emit("credenziali_inviate", this.username_tmp);
          } else {
            // Chiudo l'overlay
            this.caricamento_dati = false;

            this.$refs.SnackbarQV.print(
              "error",
              `Non è stato possibile subentrare con queste credenziali.`
            );
          }
        })
        .catch((err) => {
          if (err) {
            // Chiudo l'overlay
            this.caricamento_dati = false;

            // Stampo una snackbar di errore
            if (err.response) {
              this.$refs.SnackbarQV.print(
                "error",
                `${JSON.parse(err.response.data.message).result}.`
              );
            } else {
              this.$refs.SnackbarQV.print(
                "error",
                `Errore di comunicazione col server.`
              );
              console.error(err);
            }
          }
        });
    },
  },
  created() {},
  mounted() {
    this.getTurni();
  },
};
</script>
<style scoped>
</style>